import React, {
  Fragment,
  useState,
  useEffect,
  useRef,
  useLayoutEffect,
  memo,
} from "react";
import styled from "styled-components";
import { View, Text, SlideImage } from "./components";
import { CenteredText } from "./components/Gallery";
import { useQuery } from "react-apollo";
import tagAlbumsQuery from "./graphql/tagAlbumsQueryEducation";
import albumQuery from "./graphql/albumQuery";
import friendlyUrl from "slug";
import Footer from "./Footer";
import Spinner from "./components/Spinner";
import { getProfessions } from "./helpers";
import { getHash, removeHash } from "./utilities/hash";
import { Redirect } from "@reach/router";
import { useDidMount } from "react-hooks-lib";
import { scrollDown } from "./App";
import LogoSmall from "./components/LogoSmall";

const offset = 110;

const Container = styled(View)`
  min-height: 100vmin;
`;

const CategoryItemsContainer = styled(View)`
  display: flex;
  justify-content: space-between;
  width: 100%;
  white-space: nowrap;
`;

const StickyHeader = styled(View)`
  position: sticky;
  top: 0;
  ${({ collapse }) => collapse && "top: -66px"};
  @media (max-height: 320px) {
    position: relative;
    top: 0;
  }
  z-index: 30;
  background-color: var(--bg-color);
  transition: background-color 400ms ease;
  background-color: ${(props) => props.bg};
`;

const RatioContainer = styled(View)`
  position: relative;
  height: 0;
  padding-bottom: ${(props) => (props.ratio ? 100 / props.ratio : 33)}%;
  overflow-y: visible;
`;

function Artist(props) {
  useDidMount(() => scrollDown());

  const [bg, setBG] = useState(() => {
    let para = window.document.querySelector("body");
    let compStyles = window.getComputedStyle(para);
    /*
    console.log(
      "current bg color: " + compStyles.getPropertyValue("background-color")
    );
    */
    return compStyles.getPropertyValue("background-color");
  });

  useLayoutEffect(() => {
    setBG("white");
  }, []);

  const { data: allAlbumData } = useQuery(albumQuery, {
    fetchPolicy: "cache-and-network",
    variables: {
      user: process.env.REACT_APP_WHITESPACE_USER,
      slug: `education-bio`,
    },
  });

  const albumData =
    allAlbumData?.allAlbums &&
    allAlbumData?.allAlbums.length > 0 &&
    allAlbumData?.allAlbums[0];
  const artistTag = allAlbumData?.User
    ? allAlbumData.User.tags.find(
        (tag) => friendlyUrl(tag.name) === "education"
      )
    : null;
  const artistTagName = artistTag ? artistTag.name : null;

  const tags = albumData?.tags;
  // const profession = tag ? tag.name : null
  if (albumData) {
    // console.log("profession ", getProfessions(albumData.tags))
  }

  useEffect(() => {
    sessionStorage.setItem("whereWasI", "artist");
  }, []);

  const [inView, setInView] = useState({});

  const { data, loading, error } = useQuery(tagAlbumsQuery, {
    fetchPolicy: "cache-and-network",
    variables: {
      user: process.env.REACT_APP_WHITESPACE_USER,
      tagName: "Education",
    },
  });

  if (tags?.find((tag) => tag.name === "Removed")) {
    return <Redirect noThrow to="/" />;
  }

  const albums = data?.allTags[0]?.albums;

  const categoryAlbums = albums
    ? [
        {
          category: "None",
          albums: albums.filter((album) => {
            // console.log(album.tags);
            return !album.tags.find((tag) => tag.name === "Bio");
          }),
        },
      ]
    : null;

  return (
    <Fragment>
      {/* <MobileHeader /> */}
      <View style={{ marginLeft: "auto", marginRight: "auto" }} my={5}>
        <LogoSmall
          style={{
            position: "relative",
            marginTop: 0,
            marginLeft: "auto",
            marginRight: "auto",
            paddingRight: 0,
          }}
        />
        <Text textStyle="navigation" mt={6} center>
          EDUCATION
        </Text>
      </View>

      {/*!props.isWide && (
        <ToggleOverlayMenu>
          {({ on, toggle }) =>
            on ? (
              <CloseIcon
                style={{
                  position: "fixed",
                  top: 20,
                  right: 0,
                  left: "auto",
                  zIndex: 999,
                }}
                mr={[4, 4, 5]}
                onClick={toggle}
              />
            ) : (
              <MenuIcon
                style={{
                  position: "fixed",
                  top: 20,
                  right: 0,
                  left: "auto",
                  zIndex: 999,
                }}
                mr={[4, 4, 5]}
                onClick={toggle}
              />
            )
          }
        </ToggleOverlayMenu>
        )*/}
      <View>
        <View style={{ minHeight: "100vh" }}>
          {/* <StickyOrNot
          pt={props.isWide ? 4 : 0}
          pb={props.isWide ? 1 : 1}
          bg={bg}
          collapse={isMobile}
        >
          {props.isWide && <LogoSmall style={{ paddingRight: 0 }} />}
          {!artistTagName && (
            <Container pt={4} style={{ minHeight: "100vh" }}>
              <Spinner />
            </Container>
          )}

        </StickyOrNot> */}
          {!artistTagName && (
            <Container pt={4} style={{ minHeight: "100vh" }}>
              <Spinner />
            </Container>
          )}

          {loading && !data?.allTags && (
            <Fragment>
              <Container pt={4}>
                <Spinner />
              </Container>
            </Fragment>
          )}
          {error && !data?.allTags && <Text>{`Error! ${error.message}`}</Text>}

          {!!categoryAlbums?.length > 0 && (
            <Fragment>
              {categoryAlbums.map(
                ({ albums, category: categoryLabel }, index) => {
                  // if (albums.length === 0) return null

                  const category = categoryLabel.split(" Only").join("");
                  const slides = albums
                    .sort((a, b) => b.order - a.order)
                    .map((album) => {
                      const to = friendlyUrl(album.title.split(" - ")[1]);
                      return album.slides.length > 0
                        ? {
                            ...album.slides[0],
                            to,
                            albumTitle: album.title.split(" - ")[1],
                            profession: getProfessions(album.tags).join(" - "),
                            keyValues: album.keyValues,
                            slides: album.slides,
                          }
                        : {
                            to,
                            albumTitle: album.title.split(" - ")[1],
                            profession: getProfessions(album.tags).join(" - "),
                          };
                    });
                  return (
                    <Section
                      key={friendlyUrl(category)}
                      setInView={
                        (value) => {}
                        /*
                        setInView({
                          ...inView,
                          [friendlyUrl(category)]: value,
                        })
                        */
                      }
                      id={friendlyUrl(category)}
                    >
                      {/* props.category !== "bio" && (
                        <Fragment>
                          {index > 0 && <Divider mb={6} />}
                          <ArtistProjectOverview slides={slides} education />
                        </Fragment>
                      )*/}
                      {slides.map((slides) => {
                        return slides.slides.find(
                          (slide) => slide.description?.length > 2
                        ) ? (
                          <Fragment>
                            {slides.slides.map((slide) => {
                              return slide.description?.length > 2 ? (
                                <CenteredText content={slide.description} />
                              ) : null;
                            })}
                          </Fragment>
                        ) : (
                          <View
                            style={{
                              width: "20vw",
                              maxWidth: 500,
                              minWidth: 220,
                              position: "relative",
                              marginLeft: "auto",
                              marginRight: "auto",
                            }}
                            mb={4}
                          >
                            <RatioContainer
                              ratio={
                                slides.slides[0].width / slides.slides[0].height
                              }
                            >
                              <SlideImage instant slide={slides.slides[0]} />
                            </RatioContainer>
                          </View>
                        );
                      })}
                    </Section>
                  );
                }
              )}
              {/* <Section
                    setInView={value =>
                      setInView({ ...inView, ["bio"]: value })
                    }
                    id="bio"
                  >
                    <Bio artist="education" />
                  </Section> */}
              {/* <ScrollToSectionIfNeeded key={props.artist} /> */}
            </Fragment>
          )}
        </View>
        <Footer isWide={props.isWide} />
      </View>
    </Fragment>
  );
}

const ScrollToSectionIfNeeded = () => {
  useLayoutEffect(() => {
    const hash = getHash();
    console.log(hash);
    if (hash && hash.length > 1) {
      const id = hash;
      const $anchor = document.getElementById(id);
      if ($anchor) {
        const offsetTop =
          $anchor.getBoundingClientRect().top + window.pageYOffset;
        setTimeout(
          () =>
            window.scroll({
              top: offsetTop - offset,
              behavior: "smooth",
            }),
          600
        );
      }
      removeHash();
    }
  }, []);
  return null;
};
/*

                  }}
                </Categories>
                <Bio artist={props.artist} />
              </Fragment>

              */

export default memo(Artist);

const Section = ({ id, setInView, children }) => {
  const ref = useRef();
  const onScreen = useOnScreen(ref);
  useEffect(() => {
    // setInView(onScreen);
  }, [onScreen, setInView]);
  return (
    <section id={id} ref={ref}>
      {children}
    </section>
  );
};

// Hook
const useOnScreen = (ref, rootMargin = "-160px") => {
  // State and setter for storing whether element is visible
  const [isIntersecting, setIntersecting] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        // Update our state when observer callback fires
        setIntersecting(entry.isIntersecting);
      },
      {
        rootMargin,
      }
    );
    if (ref.current) {
      observer.observe(ref.current);
    }
    return () => {
      observer.unobserve(ref.current);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []); // Empty array ensures that effect is only run on mount and unmount

  return isIntersecting;
};
